// extracted by mini-css-extract-plugin
export var legendIndicator = "_do-1";
export var legendRight = "_do-0";